/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginModel } from '../../modules/loadbalancer/shared';

@Injectable()
export class ExternalUtilsService {
    /**
     * Format error message
     * @param user
     * @param error
     */
    public formatErrorMessage(error: any, user?: LoginModel): object {
        let errorMessage: object;
        if (error.error instanceof ProgressEvent) {
            if (user.applianceAddress && user.appliancePort) {
                errorMessage = {
                    message: 'Verify host certificate authority',
                    url: `https://${user.applianceAddress}:${user.appliancePort}/api/v1/confirm`
                };
            } else {
                errorMessage = {
                    message: 'Unable to verify user and host certificate authority'
                };
            }
        } else if (error instanceof HttpErrorResponse) {
            if (error.status === 0) {
                errorMessage = {
                    message: 'Unable to connect'
                };
            } else {
                if (error.error?.message) {
                    errorMessage = { message: this.capitaliseFirstLetter(error.error.message) };
                } else {
                    errorMessage = { message: `${error.status} - ${error.statusText}` };
                }
            }
        } else {
            errorMessage = {
                message: error.message
            };
        }

        return errorMessage;
    }

    /**
     * Get message from error.
     * @param error
     */
    public getMessageFromError(error: any): string {
        return this.capitaliseFirstLetter(
            error.error?.message ? error.error.message : error.message
        );
    }

    /**
     * Capitalise first letter.
     * @param message
     * @private
     */
    private capitaliseFirstLetter(message: string): string {
        return message.charAt(0).toUpperCase() + message.slice(1);
    }
}
